const spreadDesignPrefix = "spreadDesign:";

export type SpreadDesignId = eXpress.OfType<"SpreadDesignId"> & string;

function buildSpreadDesignId(
	leftPageHash: eXpress.LayoutHash | undefined,
	rightPageHash: eXpress.LayoutHash | undefined,
) {
	return `${spreadDesignPrefix}${leftPageHash ?? ""}-${rightPageHash ?? ""}` as SpreadDesignId;
}

/** A combination of PageDesign hashes */
export const SpreadDesignId = {
	fromPageDesigns: (pageDesigns: eXpress.creator.IConfigurationLayoutItem[]) => {
		// Use a fix left/rigSpreadDesignIdht position, so page design on the left or right page has a different spread hash
		const left = pageDesigns.find((pageDesign) =>
			pageDesign.placement.hasAny(
				eXpress.creator.LayoutPlacement.Single + eXpress.creator.LayoutPlacement.Left,
			),
		);
		const right = pageDesigns.find((pageDesign) =>
			pageDesign.placement.hasAny(eXpress.creator.LayoutPlacement.Right),
		);

		return buildSpreadDesignId(left?.layoutHash, right?.layoutHash);
	},

	fromSpread: (spread: eXpress.core.Spread) => {
		return buildSpreadDesignId(spread.leftPage?.layoutHash, spread.rightPage?.layoutHash);
	},

	isSpreadDesignId: (spreadDesignId: string) =>
		spreadDesignId.startsWith(spreadDesignPrefix) && spreadDesignId.includes("-"),
};
